<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-img
          v-if="$i18n.locale == 'cs'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_cs.png"
        ></v-img>
        <v-img
          v-if="$i18n.locale == 'en'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_en.png"
        ></v-img>
        <v-img
          v-if="$i18n.locale == 'de'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_de.png"
        ></v-img>
        <v-img
          v-if="$i18n.locale == 'sk'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_sk.png"
        ></v-img>
        <v-img
          v-if="$i18n.locale == 'hu'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_hu.png"
        ></v-img>
        <v-img
          v-if="$i18n.locale == 'pl'"
          max-height="24"
          max-width="24"
          src="@/assets/flag_pl.png"
        ></v-img>
      </v-btn>
    </template>

    <v-list>
      <v-list-item-group @change="localeChange">
        <v-list-item v-for="(item, i) in locales" :key="i">
          <v-list-item-title>{{ $t(item) }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "LocaleSelect",

  computed: {
    locales() {
      return this.$store.state.locales;
    },
  },

  methods: {
    localeChange(loc) {
      console.log("zmena locale: " + this.locales[loc]);
      this.$i18n.locale = this.locales[loc];
      this.$vuetify.lang.current = this.locales[loc];
      this.$store.dispatch("localeChange", this.locales[loc]);
      this.$router.push({
        name: this.$route.name,
        query: {lang: this.$i18n.locale}
      });
      
    },
  },
};
</script>
